import { AudioModelType, axiosInstance } from '../../utils';
import { AudioPreview } from '../../@types';

interface Payload {
  text: string;
  audioId: string;
  modelName: AudioModelType;
}

export const getAudioPreview = async (payload: Payload): Promise<AudioPreview> => {
  const res = await axiosInstance.post('/api/audios/audio-preview', payload);
  return res.data;
};
